import React from "react";
import CardFormPage from "./CardFormPage";

function CardEditPage() {
  return <CardFormPage mode="edit" />;
}

export default CardEditPage;
